import React, { useEffect, useState } from "react";
import { Link as DomLink } from "react-router-dom";
import { Mobile, Default } from "../../../utils/deviceHelpers";
import api from "../../../utils/api";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import remarkGfm from "remark-gfm";
import LandingFooter from "../../pages/static/LandingFooter";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import qs from "qs";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { constants } from "../../../utils";

export default function AuctionHomePage(props) {
  const initialTab =
    props.match.params.Tab === "sell"
      ? "Sell"
      : props.match.params.Tab === "buy"
      ? "Buy"
      : props.match.params.Tab === "myauction"
      ? "myAuction"
      : "Main";
  const [isLoaded, setIsLoaded] = useState(false);
  const [tab, setTab] = useState(initialTab);
  const [Banner, setBanner] = useState();
  const [UpcomingAuctions, setUpcomingAuctions] = useState();
  const [MainTop, setMainTop] = useState();
  const [HowItWorksImage, setHowItWorksImage] = useState();
  const [MainSellText, setMainSellText] = useState();
  const [MainBuyText, setMainBuyText] = useState();
  const [MyAuctionPlugIn, setMyAuctionPlugIn] = useState();
  const [SellImageTextTop, setSellImageTextTop] = useState();
  const [SellImageTextMiddle, setSellImageTextMiddle] = useState();
  const [SellImageTextFAQ, setSellImageTextFAQ] = useState();
  const [BuyImageTextTop, setBuyImageTextTop] = useState();
  const [BuyImageTextMiddle, setBuyImageTextMiddle] = useState();
  const [BuyImageTextFAQ, setBuyImageTextFAQ] = useState();
  const [myAuctionTextTop, setmyAuctionTextTop] = useState();
  const [myAuctionHowItWorksImage, setmyAuctionHowItWorksImage] = useState();
  const [myAuctionFAQ, setmyAuctionFAQ] = useState();
  const [GreenRectangle, setGreenRectangle] = useState();
  const [FooterIcons, setFooterIcons] = useState();
  const frontImageUrl = constants.CMS_FRONT_IMAGE_URL;

  useEffect(() => {
    window.scrollTo(0, 0);
    const query = qs.stringify({
      populate: {
        Banner: {
          populate: "*",
        },
        UpcomingAuctions: {
          populate: "*",
        },
        MainTop: {
          populate: "*",
        },
        HowItWorksImage: {
          populate: "*",
        },
        MainSellText: {
          populate: "*",
        },
        MainBuyText: {
          populate: "*",
        },
        MyAuctionPlugIn: {
          populate: "*",
        },
        SellImageTextTop: {
          populate: "*",
        },
        SellImageTextMiddle: {
          populate: "*",
        },
        SellImageTextFAQ: {
          populate: "*",
        },
        BuyImageTextTop: {
          populate: "*",
        },
        BuyImageTextMiddle: {
          populate: "*",
        },
        BuyImageTextFAQ: {
          populate: "*",
        },
        myAuctionTextTop: {
          populate: "*",
        },
        myAuctionHowItWorksImage: {
          populate: "*",
        },
        myAuctionFAQ: {
          populate: "*",
        },
        GreenRectangle: {
          populate: "*",
        },
        FooterIcons: {
          populate: "*",
        },
      },
    });
    api.fetchStrapi(`/diamond-auction?${query}`).then((response) => {
      setBanner(response.data.data.attributes.Banner.data.attributes);
      setUpcomingAuctions(response.data.data.attributes.UpcomingAuctions);
      setMainTop(response.data.data.attributes.MainTop);
      setHowItWorksImage(
        response.data.data.attributes.HowItWorksImage.data.attributes
      );
      setMainSellText(response.data.data.attributes.MainSellText);
      setMainBuyText(response.data.data.attributes.MainBuyText);
      setMyAuctionPlugIn(response.data.data.attributes.MyAuctionPlugIn);
      setSellImageTextTop(response.data.data.attributes.SellImageTextTop);
      setSellImageTextMiddle(response.data.data.attributes.SellImageTextMiddle);
      setSellImageTextFAQ(response.data.data.attributes.SellImageTextFAQ);
      setBuyImageTextTop(response.data.data.attributes.BuyImageTextTop);
      setBuyImageTextMiddle(response.data.data.attributes.BuyImageTextMiddle);
      setBuyImageTextFAQ(response.data.data.attributes.BuyImageTextFAQ);
      setmyAuctionTextTop(response.data.data.attributes.myAuctionTextTop);
      setmyAuctionHowItWorksImage(
        response.data.data.attributes.myAuctionHowItWorksImage.data.attributes
      );
      setmyAuctionFAQ(response.data.data.attributes.myAuctionFAQ);
      setGreenRectangle(response.data.data.attributes.GreenRectangle);
      setFooterIcons(response.data.data.attributes.FooterIcons);
      setIsLoaded(true);
    });
  }, []);

  return (
    <>
      {!isLoaded ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <Container maxWidth="xl" className="careers-text">
          <Mobile>
            <Stack spacing={3} alignItems="center">
              {Banner && tab === "Main" && (
                <img
                  src={`${frontImageUrl}${Banner.url}`}
                  width="100%"
                  alt="banner"
                />
              )}
              <Stack spacing={2} sx={{ marginTop: "1rem" }}>
                <Chip
                  label={
                    <Typography variant="diamondTabFont">General</Typography>
                  }
                  sx={{ width: "20rem", padding: "1rem" }}
                  variant={tab === "Main" ? "filled" : "outlined"}
                  color="primary"
                  onClick={() => {
                    setTab("Main");
                    window.scrollTo(0, 0);
                  }}
                />
                <Chip
                  label={
                    <Typography variant="diamondTabFont">
                      Sell Diamonds
                    </Typography>
                  }
                  sx={{ width: "20rem", padding: "1rem" }}
                  variant={tab === "Sell" ? "filled" : "outlined"}
                  color="primary"
                  onClick={() => {
                    setTab("Sell");
                    window.scrollTo(0, 0);
                  }}
                />
                <Chip
                  label={
                    <Typography variant="diamondTabFont">
                      Buy Diamonds
                    </Typography>
                  }
                  sx={{ width: "20rem", padding: "1rem" }}
                  variant={tab === "Buy" ? "filled" : "outlined"}
                  color="primary"
                  onClick={() => {
                    setTab("Buy");
                    window.scrollTo(0, 0);
                  }}
                />
                <Chip
                  label={
                    <Typography variant="diamondTabFont">myAuction</Typography>
                  }
                  sx={{ width: "20rem", padding: "1rem" }}
                  variant={tab === "myAuction" ? "filled" : "outlined"}
                  color="primary"
                  onClick={() => {
                    setTab("myAuction");
                    window.scrollTo(0, 0);
                  }}
                />
              </Stack>
              {tab === "Main" && (
                <Stack spacing={3}>
                  <Stack
                    sx={{
                      padding: "2rem",
                      border: "3px solid #D2B48C",
                    }}
                    spacing={2}
                  >
                    <Typography variant="diamondTabFont" className="center">
                      UPCOMING AUCTIONS
                    </Typography>
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: {
                          sm: "repeat(1, 1fr)",
                          md: "repeat(2, 1fr)",
                          lg: "repeat(2, 1fr)",
                          xl: "repeat(2, 1fr)",
                        },
                        gridColumnGap: "3rem",
                      }}
                    >
                      <Typography variant="staticText">
                        <ReactMarkdown remarkGfm={[remarkGfm]}>
                          {UpcomingAuctions.body}
                        </ReactMarkdown>
                      </Typography>
                      <Stack
                        spacing={1}
                        alignItems="center"
                        justifyContent="center"
                      >
                        <DomLink
                          to={{
                            pathname: "/harmony-auction-signup",
                          }}
                          className="center"
                        >
                          <Button
                            color="success"
                            variant="contained"
                            size="small"
                          >
                            Sign-Up <br /> (it's free)
                          </Button>
                        </DomLink>
                        <Stack direction="row" spacing={1}>
                          <Typography sx={{ color: "#7fa04d" }}>
                            Already Participating?{" "}
                          </Typography>
                          <DomLink
                            to={{
                              pathname: "/myauction-log-in",
                            }}
                            className="center"
                          >
                            <Typography
                              sx={{
                                color: "#7fa04d",
                                textDecoration: "underline",
                              }}
                            >
                              Login
                            </Typography>
                          </DomLink>
                        </Stack>
                      </Stack>
                    </Box>
                  </Stack>
                  <Typography variant="staticText" sx={{ padding: "2rem" }}>
                    <ReactMarkdown remarkGfm={[remarkGfm]}>
                      {MainTop.body}
                    </ReactMarkdown>
                  </Typography>
                  <Divider flexItem />
                  {HowItWorksImage && (
                    <Stack
                      sx={{ width: "100%" }}
                      alignItems="center"
                      spacing={2}
                    >
                      <Typography variant="articleTitle">
                        How It Works
                      </Typography>
                      <img
                        src={`${frontImageUrl}${HowItWorksImage.url}`}
                        width="100%"
                        alt="banner"
                      />
                    </Stack>
                  )}
                  <Divider flexItem />
                  {MainSellText && (
                    <Stack
                      sx={{
                        padding: "3rem",
                        border: "3px solid #D2B48C",
                      }}
                      spacing={2}
                      alignItems="center"
                    >
                      <Typography variant="articleTitle">
                        {MainSellText.title}
                      </Typography>
                      <Typography variant="staticText">
                        <ReactMarkdown remarkGfm={[remarkGfm]}>
                          {MainSellText.body}
                        </ReactMarkdown>
                      </Typography>
                      <Chip
                        label={
                          <Typography variant="diamondTabFont">
                            Learn More
                          </Typography>
                        }
                        sx={{ width: "20rem", padding: "1rem" }}
                        color="primary"
                        onClick={() => setTab("Sell")}
                      />
                    </Stack>
                  )}
                  {MainBuyText && (
                    <Stack
                      sx={{
                        padding: "3rem",
                        border: "3px solid #D2B48C",
                      }}
                      spacing={2}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Typography variant="articleTitle">
                        {MainBuyText.title}
                      </Typography>
                      <Typography variant="staticText">
                        <ReactMarkdown remarkGfm={[remarkGfm]}>
                          {MainBuyText.body}
                        </ReactMarkdown>
                      </Typography>
                      <Chip
                        label={
                          <Typography variant="diamondTabFont">
                            Learn More
                          </Typography>
                        }
                        sx={{ width: "20rem", padding: "1rem" }}
                        color="primary"
                        onClick={() => setTab("Buy")}
                      />
                    </Stack>
                  )}
                  <Divider flexItem />
                  {MyAuctionPlugIn && (
                    <Stack
                      sx={{
                        padding: "3rem",
                        border: "3px solid #7fa04d",
                      }}
                      spacing={2}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Typography variant="articleTitle">
                        {MyAuctionPlugIn.title}
                      </Typography>
                      <Typography variant="staticText">
                        <ReactMarkdown remarkGfm={[remarkGfm]}>
                          {MyAuctionPlugIn.body}
                        </ReactMarkdown>
                      </Typography>
                      <Chip
                        label={
                          <Typography variant="diamondTabFont">
                            Learn More
                          </Typography>
                        }
                        sx={{ width: "20rem", padding: "1rem" }}
                        color="primary"
                        onClick={() => setTab("myAuction")}
                      />
                      <div>
                        <img
                          src={`${frontImageUrl}${MyAuctionPlugIn.image.data.attributes.url}`}
                          width="100%"
                          alt="banner"
                        />
                      </div>
                    </Stack>
                  )}
                </Stack>
              )}
              {tab === "Sell" && (
                <Stack spacing={3}>
                  {SellImageTextTop && (
                    <Stack
                      sx={{
                        width: "100%",
                      }}
                      spacing={2}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <div>
                        <img
                          src={`${frontImageUrl}${SellImageTextTop.image.data.attributes.url}`}
                          alt="banner"
                          width="100%"
                        />
                      </div>
                      <Typography variant="h3">
                        {SellImageTextTop.title}
                      </Typography>
                      <Typography variant="staticText">
                        <ReactMarkdown remarkGfm={[remarkGfm]}>
                          {SellImageTextTop.body}
                        </ReactMarkdown>
                      </Typography>
                    </Stack>
                  )}
                  <Divider flexItem />
                  {SellImageTextMiddle && (
                    <Stack
                      sx={{
                        width: "100%",
                      }}
                      spacing={2}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Typography variant="h3">
                        {SellImageTextMiddle.title}
                      </Typography>
                      <img
                        src={`${frontImageUrl}${SellImageTextMiddle.image.data.attributes.url}`}
                        alt="banner"
                        width="100%"
                      />
                      <Typography variant="staticText">
                        <ReactMarkdown remarkGfm={[remarkGfm]}>
                          {SellImageTextMiddle.body}
                        </ReactMarkdown>
                      </Typography>
                      <DomLink
                        to={{
                          pathname: "/harmony-auction-signup",
                        }}
                        className="center"
                      >
                        <Button
                          color="success"
                          variant="contained"
                          size="small"
                        >
                          Open a Seller Account
                        </Button>
                      </DomLink>
                      <Stack direction="row" spacing={1}>
                        <Typography sx={{ color: "#7fa04d" }}>
                          Already Participating?{" "}
                        </Typography>
                        <DomLink
                          to={{
                            pathname: "/myauction-log-in",
                          }}
                          className="center"
                        >
                          <Typography
                            sx={{
                              color: "#7fa04d",
                              textDecoration: "underline",
                            }}
                          >
                            Login
                          </Typography>
                        </DomLink>
                      </Stack>
                    </Stack>
                  )}
                  <Divider flexItem />
                  {SellImageTextFAQ && (
                    <Stack
                      sx={{
                        width: "100%",
                      }}
                      spacing={2}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <img
                        src={`${frontImageUrl}${SellImageTextFAQ.image.data.attributes.url}`}
                        alt="banner"
                        width="100%"
                      />
                      <Stack
                        sx={{
                          padding: "2rem",
                          border: "3px solid #D2B48C",
                        }}
                        spacing={2}
                      >
                        <Typography variant="diamondTabFont" className="center">
                          UPCOMING AUCTIONS
                        </Typography>
                        <Typography variant="staticText">
                          <ReactMarkdown remarkGfm={[remarkGfm]}>
                            {UpcomingAuctions.body}
                          </ReactMarkdown>
                        </Typography>
                      </Stack>
                      <Typography variant="h3">
                        {SellImageTextFAQ.title}
                      </Typography>
                      <Typography variant="staticText">
                        <ReactMarkdown remarkGfm={[remarkGfm]}>
                          {SellImageTextFAQ.body}
                        </ReactMarkdown>
                      </Typography>
                    </Stack>
                  )}
                </Stack>
              )}
              {tab === "Buy" && (
                <Stack spacing={3}>
                  {BuyImageTextTop && (
                    <Stack
                      sx={{
                        width: "100%",
                      }}
                      spacing={2}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <img
                        src={`${frontImageUrl}${BuyImageTextTop.image.data.attributes.url}`}
                        width="100%"
                        alt="banner"
                      />
                      <Typography variant="h3">
                        {BuyImageTextTop.title}
                      </Typography>
                      <Typography variant="staticText">
                        <ReactMarkdown remarkGfm={[remarkGfm]}>
                          {BuyImageTextTop.body}
                        </ReactMarkdown>
                      </Typography>
                    </Stack>
                  )}
                  <Divider flexItem />
                  {BuyImageTextMiddle && (
                    <Stack
                      sx={{
                        width: "100%",
                      }}
                      spacing={2}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <img
                        src={`${frontImageUrl}${BuyImageTextMiddle.image.data.attributes.url}`}
                        alt="banner"
                        width="100%"
                      />
                      <Typography variant="h3">
                        {BuyImageTextMiddle.title}
                      </Typography>
                      <Typography variant="staticText">
                        <ReactMarkdown remarkGfm={[remarkGfm]}>
                          {BuyImageTextMiddle.body}
                        </ReactMarkdown>
                      </Typography>
                      <DomLink
                        to={{
                          pathname: "/harmony-auction-signup",
                        }}
                        className="center"
                      >
                        <Button
                          color="success"
                          variant="contained"
                          size="small"
                        >
                          Open a Buyer Account
                        </Button>
                      </DomLink>
                      <Stack direction="row" spacing={1}>
                        <Typography sx={{ color: "#7fa04d" }}>
                          Already Participating?{" "}
                        </Typography>
                        <DomLink
                          to={{
                            pathname: "/myauction-log-in",
                          }}
                          className="center"
                        >
                          <Typography
                            sx={{
                              color: "#7fa04d",
                              textDecoration: "underline",
                            }}
                          >
                            Login
                          </Typography>
                        </DomLink>
                      </Stack>
                    </Stack>
                  )}
                  <Divider flexItem />
                  {BuyImageTextFAQ && (
                    <Stack
                      sx={{
                        width: "100%",
                      }}
                      spacing={2}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Typography variant="h3">
                        {BuyImageTextFAQ.title}
                      </Typography>
                      <img
                        src={`${frontImageUrl}${BuyImageTextFAQ.image.data.attributes.url}`}
                        width="100%"
                        alt="banner"
                      />
                      <Stack
                        sx={{
                          padding: "2rem",
                          border: "3px solid #D2B48C",
                        }}
                        spacing={2}
                      >
                        <Typography variant="diamondTabFont" className="center">
                          UPCOMING AUCTIONS
                        </Typography>
                        <Box
                          sx={{
                            display: "grid",
                            gridTemplateColumns: {
                              sm: "repeat(1, 1fr)",
                              md: "repeat(2, 1fr)",
                              lg: "repeat(2, 1fr)",
                              xl: "repeat(2, 1fr)",
                            },
                          }}
                        >
                          <Typography variant="staticText">
                            <ReactMarkdown remarkGfm={[remarkGfm]}>
                              {UpcomingAuctions.body}
                            </ReactMarkdown>
                          </Typography>
                        </Box>
                      </Stack>
                      <Typography variant="staticText">
                        <ReactMarkdown remarkGfm={[remarkGfm]}>
                          {BuyImageTextFAQ.body}
                        </ReactMarkdown>
                      </Typography>
                    </Stack>
                  )}
                </Stack>
              )}
              {tab === "myAuction" && (
                <Stack spacing={3}>
                  {myAuctionTextTop && (
                    <Stack
                      sx={{
                        width: "100%",
                      }}
                      spacing={2}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Typography variant="h3">
                        {myAuctionTextTop.title}
                      </Typography>
                      <Typography variant="staticText">
                        <ReactMarkdown remarkGfm={[remarkGfm]}>
                          {myAuctionTextTop.body}
                        </ReactMarkdown>
                      </Typography>
                      <DomLink
                        to={{
                          pathname: "/harmony-auction-signup",
                        }}
                        className="center"
                      >
                        <Button
                          color="success"
                          variant="contained"
                          size="small"
                        >
                          Get Free Plug-In
                        </Button>
                      </DomLink>
                      <DomLink
                        to={{
                          pathname: "/harmony-auction-signup",
                        }}
                        className="center"
                      >
                        <Button color="success" variant="outlined" size="small">
                          Get A Demo
                        </Button>
                      </DomLink>
                      <iframe
                        width="100%"
                        height="315"
                        src="https://www.youtube.com/embed/mpC8A53x1mo"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                      ></iframe>
                    </Stack>
                  )}
                  <Divider flexItem />
                  {myAuctionHowItWorksImage && (
                    <img
                      src={`${frontImageUrl}${myAuctionHowItWorksImage.url}`}
                      width="100%"
                      alt="banner"
                    />
                  )}
                  <Divider flexItem />
                  {myAuctionFAQ && (
                    <Stack
                      sx={{
                        width: "100%",
                      }}
                      spacing={2}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <img
                        src={`${frontImageUrl}${myAuctionFAQ.image.data.attributes.url}`}
                        alt="banner"
                        width="100%"
                      />
                      <Typography variant="h3">{myAuctionFAQ.title}</Typography>
                      <Typography variant="staticText">
                        <ReactMarkdown remarkGfm={[remarkGfm]}>
                          {myAuctionFAQ.body}
                        </ReactMarkdown>
                      </Typography>
                    </Stack>
                  )}
                </Stack>
              )}
              <Divider flexItem />
              <Stack spacing={1} alignItems="center" justifyContent="center">
                <Typography variant="articleTitle">Questions?</Typography>
                <DomLink
                  to={{
                    pathname: "/Frequently-Asked-Questions",
                  }}
                  className="center"
                >
                  <Typography
                    variant="diamondTabFont"
                    sx={{
                      textDecoration: "underline",
                    }}
                  >
                    CLICK HERE
                  </Typography>
                </DomLink>
                <Typography variant="diamondTabFont">
                  for our frequently asked questions or contact one of our
                  specialists:
                </Typography>
                <Typography variant="diamondTabFont">
                  auction@hooverandstrong.com
                </Typography>
                <Typography variant="diamondTabFont">
                  1-800-759-9997 ext. 485
                </Typography>
              </Stack>
              <Divider flexItem />
              <Typography variant="mobileGreenRectangle" align="center">
                {GreenRectangle.text}
              </Typography>
              <LandingFooter icons={FooterIcons} />
            </Stack>
          </Mobile>
          <Default>
            <Stack spacing={3} alignItems="center">
              {Banner && tab === "Main" && (
                <img
                  src={`${frontImageUrl}${Banner.url}`}
                  width="100%"
                  alt="banner"
                />
              )}
              <Stack direction="row" spacing={2} sx={{ marginTop: "1rem" }}>
                <Chip
                  label={
                    <Typography variant="diamondTabFont">General</Typography>
                  }
                  sx={{ width: "20rem", padding: "1rem" }}
                  variant={tab === "Main" ? "filled" : "outlined"}
                  color="primary"
                  onClick={() => {
                    setTab("Main");
                    window.scrollTo(0, 0);
                  }}
                />
                <Chip
                  label={
                    <Typography variant="diamondTabFont">
                      Sell Diamonds
                    </Typography>
                  }
                  sx={{ width: "20rem", padding: "1rem" }}
                  variant={tab === "Sell" ? "filled" : "outlined"}
                  color="primary"
                  onClick={() => {
                    setTab("Sell");
                    window.scrollTo(0, 0);
                  }}
                />
                <Chip
                  label={
                    <Typography variant="diamondTabFont">
                      Buy Diamonds
                    </Typography>
                  }
                  sx={{ width: "20rem", padding: "1rem" }}
                  variant={tab === "Buy" ? "filled" : "outlined"}
                  color="primary"
                  onClick={() => {
                    setTab("Buy");
                    window.scrollTo(0, 0);
                  }}
                />
                <Chip
                  label={
                    <Typography variant="diamondTabFont">myAuction</Typography>
                  }
                  sx={{ width: "20rem", padding: "1rem" }}
                  variant={tab === "myAuction" ? "filled" : "outlined"}
                  color="primary"
                  onClick={() => {
                    setTab("myAuction");
                    window.scrollTo(0, 0);
                  }}
                />
              </Stack>
              {tab === "Main" && (
                <>
                  <Stack direction="row" spacing={3}>
                    <Stack
                      sx={{
                        padding: "2rem",
                        width: "50%",
                        border: "3px solid #D2B48C",
                      }}
                      spacing={2}
                    >
                      <Typography variant="diamondTabFont" className="center">
                        UPCOMING AUCTIONS
                      </Typography>
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: {
                            sm: "repeat(1, 1fr)",
                            md: "repeat(2, 1fr)",
                            lg: "repeat(2, 1fr)",
                            xl: "repeat(2, 1fr)",
                          },
                          gridColumnGap: "3rem",
                        }}
                      >
                        <Typography variant="staticText">
                          <ReactMarkdown remarkGfm={[remarkGfm]}>
                            {UpcomingAuctions.body}
                          </ReactMarkdown>
                        </Typography>
                        <Stack
                          spacing={1}
                          alignItems="center"
                          justifyContent="center"
                        >
                          <DomLink
                            to={{
                              pathname: "/harmony-auction-signup",
                            }}
                            className="center"
                          >
                            <Button
                              color="success"
                              variant="contained"
                              size="small"
                            >
                              Sign-Up <br /> (it's free)
                            </Button>
                          </DomLink>
                          <Stack direction="row" spacing={1}>
                            <Typography sx={{ color: "#7fa04d" }}>
                              Already Participating?{" "}
                            </Typography>
                            <DomLink
                              to={{
                                pathname: "/myauction-log-in",
                              }}
                              className="center"
                            >
                              <Typography
                                sx={{
                                  color: "#7fa04d",
                                  textDecoration: "underline",
                                }}
                              >
                                Login
                              </Typography>
                            </DomLink>
                          </Stack>
                        </Stack>
                      </Box>
                    </Stack>
                    <Typography
                      variant="staticText"
                      sx={{ width: "50%", padding: "2rem" }}
                    >
                      <ReactMarkdown remarkGfm={[remarkGfm]}>
                        {MainTop.body}
                      </ReactMarkdown>
                    </Typography>
                  </Stack>
                  <Divider flexItem />
                  {HowItWorksImage && (
                    <Stack
                      sx={{ width: "100%" }}
                      alignItems="center"
                      spacing={2}
                    >
                      <Typography variant="articleTitle">
                        How It Works
                      </Typography>
                      <img
                        src={`${frontImageUrl}${HowItWorksImage.url}`}
                        width="100%"
                        alt="banner"
                      />
                    </Stack>
                  )}
                  <Divider flexItem />
                  <Stack direction="row" spacing={3} alignItems="center">
                    {MainSellText && (
                      <Stack
                        sx={{
                          padding: "3rem",
                          width: "50%",
                          height: "50rem",
                          border: "3px solid #D2B48C",
                        }}
                        spacing={2}
                        alignItems="center"
                      >
                        <Typography variant="articleTitle">
                          {MainSellText.title}
                        </Typography>
                        <Typography variant="staticText">
                          <ReactMarkdown remarkGfm={[remarkGfm]}>
                            {MainSellText.body}
                          </ReactMarkdown>
                        </Typography>
                        <Chip
                          label={
                            <Typography variant="diamondTabFont">
                              Learn More
                            </Typography>
                          }
                          sx={{ width: "20rem", padding: "1rem" }}
                          color="primary"
                          onClick={() => setTab("Sell")}
                        />
                      </Stack>
                    )}
                    {MainBuyText && (
                      <Stack
                        sx={{
                          padding: "3rem",
                          width: "50%",
                          height: "50rem",
                          border: "3px solid #D2B48C",
                        }}
                        spacing={2}
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Typography variant="articleTitle">
                          {MainBuyText.title}
                        </Typography>
                        <Typography variant="staticText">
                          <ReactMarkdown remarkGfm={[remarkGfm]}>
                            {MainBuyText.body}
                          </ReactMarkdown>
                        </Typography>
                        <Chip
                          label={
                            <Typography variant="diamondTabFont">
                              Learn More
                            </Typography>
                          }
                          sx={{ width: "20rem", padding: "1rem" }}
                          color="primary"
                          onClick={() => setTab("Buy")}
                        />
                      </Stack>
                    )}
                  </Stack>
                  <Divider flexItem />
                  {MyAuctionPlugIn && (
                    <Stack
                      sx={{
                        padding: "3rem",
                        width: "100%",
                        border: "3px solid #7fa04d",
                      }}
                      spacing={2}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Typography variant="articleTitle">
                        {MyAuctionPlugIn.title}
                      </Typography>
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: {
                            sm: "repeat(1, 1fr)",
                            md: "repeat(2, 1fr)",
                            lg: "repeat(2, 1fr)",
                            xl: "repeat(2, 1fr)",
                          },
                          gridColumnGap: "3rem",
                        }}
                      >
                        <Stack
                          spacing={1}
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Typography variant="staticText">
                            <ReactMarkdown remarkGfm={[remarkGfm]}>
                              {MyAuctionPlugIn.body}
                            </ReactMarkdown>
                          </Typography>
                          <Chip
                            label={
                              <Typography variant="diamondTabFont">
                                Learn More
                              </Typography>
                            }
                            sx={{ width: "20rem", padding: "1rem" }}
                            color="primary"
                            onClick={() => setTab("myAuction")}
                          />
                        </Stack>
                        <img
                          src={`${frontImageUrl}${MyAuctionPlugIn.image.data.attributes.url}`}
                          alt="banner"
                        />
                      </Box>
                    </Stack>
                  )}
                </>
              )}
              {tab === "Sell" && (
                <>
                  {SellImageTextTop && (
                    <Stack
                      sx={{
                        padding: "3rem",
                        width: "100%",
                      }}
                      spacing={2}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: {
                            sm: "repeat(1, 1fr)",
                            md: "repeat(2, 1fr)",
                            lg: "repeat(2, 1fr)",
                            xl: "repeat(2, 1fr)",
                          },
                          gridColumnGap: "3rem",
                        }}
                      >
                        <div>
                          <img
                            src={`${frontImageUrl}${SellImageTextTop.image.data.attributes.url}`}
                            alt="banner"
                          />
                        </div>
                        <Stack spacing={1}>
                          <Typography variant="h3">
                            {SellImageTextTop.title}
                          </Typography>
                          <Typography variant="staticText">
                            <ReactMarkdown remarkGfm={[remarkGfm]}>
                              {SellImageTextTop.body}
                            </ReactMarkdown>
                          </Typography>
                        </Stack>
                      </Box>
                    </Stack>
                  )}
                  <Divider flexItem />
                  {SellImageTextMiddle && (
                    <Stack
                      sx={{
                        padding: "3rem",
                        width: "100%",
                      }}
                      spacing={2}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: {
                            sm: "repeat(1, 1fr)",
                            md: "repeat(2, 1fr)",
                            lg: "repeat(2, 1fr)",
                            xl: "repeat(2, 1fr)",
                          },
                          gridColumnGap: "3rem",
                        }}
                      >
                        <Stack spacing={1}>
                          <Typography variant="h3">
                            {SellImageTextMiddle.title}
                          </Typography>
                          <Typography variant="staticText">
                            <ReactMarkdown remarkGfm={[remarkGfm]}>
                              {SellImageTextMiddle.body}
                            </ReactMarkdown>
                          </Typography>
                          <Stack
                            direction="row"
                            spacing={1}
                            alignItems="center"
                            justifyContent="center"
                          >
                            <DomLink
                              to={{
                                pathname: "/harmony-auction-signup",
                              }}
                              className="center"
                            >
                              <Button
                                color="success"
                                variant="contained"
                                size="small"
                              >
                                Open a Seller Account
                              </Button>
                            </DomLink>
                            <Stack direction="row" spacing={1}>
                              <Typography sx={{ color: "#7fa04d" }}>
                                Already Participating?{" "}
                              </Typography>
                              <DomLink
                                to={{
                                  pathname: "/myauction-log-in",
                                }}
                                className="center"
                              >
                                <Typography
                                  sx={{
                                    color: "#7fa04d",
                                    textDecoration: "underline",
                                  }}
                                >
                                  Login
                                </Typography>
                              </DomLink>
                            </Stack>
                          </Stack>
                        </Stack>
                        <div className="float-right">
                          <img
                            src={`${frontImageUrl}${SellImageTextMiddle.image.data.attributes.url}`}
                            alt="banner"
                          />
                        </div>
                      </Box>
                    </Stack>
                  )}
                  <Divider flexItem />
                  {SellImageTextFAQ && (
                    <Stack
                      sx={{
                        padding: "3rem",
                        width: "100%",
                      }}
                      spacing={2}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: {
                            sm: "repeat(1, 1fr)",
                            md: "repeat(2, 1fr)",
                            lg: "repeat(2, 1fr)",
                            xl: "repeat(2, 1fr)",
                          },
                          gridColumnGap: "3rem",
                        }}
                      >
                        <div>
                          <img
                            src={`${frontImageUrl}${SellImageTextFAQ.image.data.attributes.url}`}
                            alt="banner"
                          />
                          <Stack
                            sx={{
                              padding: "2rem",
                              border: "3px solid #D2B48C",
                            }}
                            spacing={2}
                          >
                            <Typography
                              variant="diamondTabFont"
                              className="center"
                            >
                              UPCOMING AUCTIONS
                            </Typography>
                            <Box
                              sx={{
                                display: "grid",
                                gridTemplateColumns: {
                                  sm: "repeat(1, 1fr)",
                                  md: "repeat(2, 1fr)",
                                  lg: "repeat(2, 1fr)",
                                  xl: "repeat(2, 1fr)",
                                },
                              }}
                            >
                              <Typography variant="staticText">
                                <ReactMarkdown remarkGfm={[remarkGfm]}>
                                  {UpcomingAuctions.body}
                                </ReactMarkdown>
                              </Typography>
                            </Box>
                          </Stack>
                        </div>
                        <Stack spacing={1}>
                          <Typography variant="h3">
                            {SellImageTextFAQ.title}
                          </Typography>
                          <Typography variant="staticText">
                            <ReactMarkdown remarkGfm={[remarkGfm]}>
                              {SellImageTextFAQ.body}
                            </ReactMarkdown>
                          </Typography>
                        </Stack>
                      </Box>
                    </Stack>
                  )}
                </>
              )}
              {tab === "Buy" && (
                <>
                  {BuyImageTextTop && (
                    <Stack
                      sx={{
                        padding: "3rem",
                        width: "100%",
                      }}
                      spacing={2}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: {
                            sm: "repeat(1, 1fr)",
                            md: "repeat(2, 1fr)",
                            lg: "repeat(2, 1fr)",
                            xl: "repeat(2, 1fr)",
                          },
                          gridColumnGap: "3rem",
                        }}
                      >
                        <Stack spacing={1}>
                          <Typography variant="h3">
                            {BuyImageTextTop.title}
                          </Typography>
                          <Typography variant="staticText">
                            <ReactMarkdown remarkGfm={[remarkGfm]}>
                              {BuyImageTextTop.body}
                            </ReactMarkdown>
                          </Typography>
                        </Stack>
                        <div>
                          <img
                            src={`${frontImageUrl}${BuyImageTextTop.image.data.attributes.url}`}
                            alt="banner"
                          />
                        </div>
                      </Box>
                    </Stack>
                  )}
                  <Divider flexItem />
                  {BuyImageTextMiddle && (
                    <Stack
                      sx={{
                        padding: "3rem",
                        width: "100%",
                      }}
                      spacing={2}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: {
                            sm: "repeat(1, 1fr)",
                            md: "repeat(2, 1fr)",
                            lg: "repeat(2, 1fr)",
                            xl: "repeat(2, 1fr)",
                          },
                          gridColumnGap: "3rem",
                        }}
                      >
                        <div>
                          <img
                            src={`${frontImageUrl}${BuyImageTextMiddle.image.data.attributes.url}`}
                            alt="banner"
                          />
                        </div>
                        <Stack spacing={1}>
                          <Typography variant="h3">
                            {BuyImageTextMiddle.title}
                          </Typography>
                          <Typography variant="staticText">
                            <ReactMarkdown remarkGfm={[remarkGfm]}>
                              {BuyImageTextMiddle.body}
                            </ReactMarkdown>
                          </Typography>
                          <Stack
                            direction="row"
                            spacing={1}
                            alignItems="center"
                            justifyContent="center"
                          >
                            <DomLink
                              to={{
                                pathname: "/harmony-auction-signup",
                              }}
                              className="center"
                            >
                              <Button
                                color="success"
                                variant="contained"
                                size="small"
                              >
                                Open a Buyer Account
                              </Button>
                            </DomLink>
                            <Stack direction="row" spacing={1}>
                              <Typography sx={{ color: "#7fa04d" }}>
                                Already Participating?{" "}
                              </Typography>
                              <DomLink
                                to={{
                                  pathname: "/myauction-log-in",
                                }}
                                className="center"
                              >
                                <Typography
                                  sx={{
                                    color: "#7fa04d",
                                    textDecoration: "underline",
                                  }}
                                >
                                  Login
                                </Typography>
                              </DomLink>
                            </Stack>
                          </Stack>
                        </Stack>
                      </Box>
                    </Stack>
                  )}
                  <Divider flexItem />
                  {BuyImageTextFAQ && (
                    <Stack
                      sx={{
                        padding: "3rem",
                        width: "100%",
                      }}
                      spacing={2}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: {
                            sm: "repeat(1, 1fr)",
                            md: "repeat(2, 1fr)",
                            lg: "repeat(2, 1fr)",
                            xl: "repeat(2, 1fr)",
                          },
                          gridColumnGap: "3rem",
                        }}
                      >
                        <Stack spacing={1}>
                          <Typography variant="h3">
                            {BuyImageTextFAQ.title}
                          </Typography>
                          <Typography variant="staticText">
                            <ReactMarkdown remarkGfm={[remarkGfm]}>
                              {BuyImageTextFAQ.body}
                            </ReactMarkdown>
                          </Typography>
                        </Stack>
                        <div>
                          <img
                            src={`${frontImageUrl}${BuyImageTextFAQ.image.data.attributes.url}`}
                            alt="banner"
                          />
                          <Stack
                            sx={{
                              padding: "2rem",
                              border: "3px solid #D2B48C",
                            }}
                            spacing={2}
                          >
                            <Typography
                              variant="diamondTabFont"
                              className="center"
                            >
                              UPCOMING AUCTIONS
                            </Typography>
                            <Box
                              sx={{
                                display: "grid",
                                gridTemplateColumns: {
                                  sm: "repeat(1, 1fr)",
                                  md: "repeat(2, 1fr)",
                                  lg: "repeat(2, 1fr)",
                                  xl: "repeat(2, 1fr)",
                                },
                              }}
                            >
                              <Typography variant="staticText">
                                <ReactMarkdown remarkGfm={[remarkGfm]}>
                                  {UpcomingAuctions.body}
                                </ReactMarkdown>
                              </Typography>
                            </Box>
                          </Stack>
                        </div>
                      </Box>
                    </Stack>
                  )}
                </>
              )}
              {tab === "myAuction" && (
                <>
                  {myAuctionTextTop && (
                    <Stack
                      sx={{
                        padding: "3rem",
                        width: "100%",
                      }}
                      spacing={2}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: {
                            sm: "repeat(1, 1fr)",
                            md: "repeat(2, 1fr)",
                            lg: "repeat(2, 1fr)",
                            xl: "repeat(2, 1fr)",
                          },
                          gridColumnGap: "3rem",
                        }}
                      >
                        <Stack spacing={1}>
                          <Typography variant="h3">
                            {myAuctionTextTop.title}
                          </Typography>
                          <Typography variant="staticText">
                            <ReactMarkdown remarkGfm={[remarkGfm]}>
                              {myAuctionTextTop.body}
                            </ReactMarkdown>
                          </Typography>
                          <Stack
                            direction="row"
                            spacing={1}
                            alignItems="center"
                            justifyContent="center"
                          >
                            <DomLink
                              to={{
                                pathname: "/harmony-auction-signup",
                              }}
                              className="center"
                            >
                              <Button
                                color="success"
                                variant="contained"
                                size="small"
                              >
                                Get Free Plug-In
                              </Button>
                            </DomLink>
                            <DomLink
                              to={{
                                pathname: "/harmony-auction-signup",
                              }}
                              className="center"
                            >
                              <Button
                                color="success"
                                variant="outlined"
                                size="small"
                              >
                                Get A Demo
                              </Button>
                            </DomLink>
                          </Stack>
                        </Stack>
                        <div>
                          <iframe
                            width="560"
                            height="315"
                            src="https://www.youtube.com/embed/mpC8A53x1mo"
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                          ></iframe>
                        </div>
                      </Box>
                    </Stack>
                  )}
                  <Divider flexItem />
                  {myAuctionHowItWorksImage && (
                    <img
                      src={`${frontImageUrl}${myAuctionHowItWorksImage.url}`}
                      width="100%"
                      alt="banner"
                    />
                  )}
                  <Divider flexItem />
                  {myAuctionFAQ && (
                    <Stack
                      sx={{
                        padding: "3rem",
                        width: "100%",
                      }}
                      spacing={2}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: {
                            sm: "repeat(1, 1fr)",
                            md: "repeat(2, 1fr)",
                            lg: "repeat(2, 1fr)",
                            xl: "repeat(2, 1fr)",
                          },
                          gridColumnGap: "3rem",
                        }}
                      >
                        <div>
                          <img
                            src={`${frontImageUrl}${myAuctionFAQ.image.data.attributes.url}`}
                            alt="banner"
                          />
                        </div>
                        <Stack spacing={1}>
                          <Typography variant="h3">
                            {myAuctionFAQ.title}
                          </Typography>
                          <Typography variant="staticText">
                            <ReactMarkdown remarkGfm={[remarkGfm]}>
                              {myAuctionFAQ.body}
                            </ReactMarkdown>
                          </Typography>
                        </Stack>
                      </Box>
                    </Stack>
                  )}
                </>
              )}
              <Divider flexItem />
              <Stack spacing={1} alignItems="center" justifyContent="center">
                <Typography variant="articleTitle">Questions?</Typography>
                <Stack direction="row" spacing={1}>
                  <DomLink
                    to={{
                      pathname: "/Frequently-Asked-Questions",
                    }}
                    className="center"
                  >
                    <Typography
                      variant="diamondTabFont"
                      sx={{
                        textDecoration: "underline",
                      }}
                    >
                      CLICK HERE
                    </Typography>
                  </DomLink>
                  <Typography variant="diamondTabFont">
                    for our frequently asked questions or contact one of our
                    specialists:
                  </Typography>
                </Stack>
                <Typography variant="diamondTabFont">
                  auction@hooverandstrong.com
                </Typography>
                <Typography variant="diamondTabFont">
                  1-800-759-9997 ext. 485
                </Typography>
              </Stack>
              <Divider flexItem />
              <Typography variant="greenRectangle" align="center">
                {GreenRectangle.text}
              </Typography>
              <LandingFooter icons={FooterIcons} />
            </Stack>
          </Default>
        </Container>
      )}
    </>
  );
}
